module.exports = __webpack_public_path__ + "static/Bugbear-17d16d54d91d630edbfa0b802db04fcf.jpg";